<script setup lang="ts">
const props = defineProps<{
  open?: boolean
}>()

const emit = defineEmits(['hide'])
</script>

<template>
  <div
    class=" row-start-1 row-end-1 col-start-1 col-end-1 px-2xl xl:py-15 flex flex-col gap-12 transform-gpu duration-400 ease-in-out z-80 overflow-y-auto"
    :class="props.open ? 'translate-y-0 bg-background-1 max-h-[calc(100svh-72px)] xl:max-h-none pointer-events-auto' : '-translate-y-full pointer-events-none'"
  >
    <NuxtLink
      to="/prywatny-dom-opieki/"
      class="py-2.5 px-3 border-b border-Tertiary w-fit"
      @click="emit('hide')"
    >
      <span class="text-H4 font-semibold! text-Tekst">Prywatny dom opieki</span>
    </NuxtLink>
    <div
      class="flex flex-col xl:flex-row xl:gap-20 justify-between"
      @click="emit('hide')"
    >
      <div class="flex flex-col flex-1">
        <AppButton2
          href="/prywatny-dom-opieki/#opieka-i-bezpieczeństwo"
          class="w-full"
        >
          <span class="text-Menu">Opieka i bezpieczeństwo</span>
        </AppButton2>
        <AppButton2
          href="/prywatny-dom-opieki/#rehabilitacja"
          class="w-full"
        >
          <span class="text-Menu">Rehabilitacja</span>
        </AppButton2>
        <AppButton2
          href="/prywatny-dom-opieki/#pokoje-i-przestrzenie-wspolne"
          class="w-full"
        >
          <span class="text-Menu">Pokoje i przestrzenie wspólne</span>
        </AppButton2>
        <AppButton2
          href="/prywatny-dom-opieki/#plan-inwestycji"
          class="w-full"
        >
          <span class="text-Menu">Plan inwestycji</span>
        </AppButton2>
      </div>
      <div class="flex flex-col flex-1">
        <AppButton2
          href="/prywatny-dom-opieki/#wyszukaj-mieszkanie"
          class="w-full"
        >
          <span class="text-Menu">Wyszukaj mieszkanie</span>
        </AppButton2>
        <AppButton2
          href="/prywatny-dom-opieki/#lokalizacja"
          class="w-full"
        >
          <span class="text-Menu">Lokalizacja</span>
        </AppButton2>
        <AppButton2
          href="/prywatny-dom-opieki/#wyzywienie"
          class="w-full"
        >
          <span class="text-Menu">Wyżywienie</span>
        </AppButton2>
        <AppButton2
          href="/prywatny-dom-opieki/#aktywnosci-i-zycie-spoleczne"
          class="w-full"
        >
          <span class="text-Menu">Aktywności i życie społeczne</span>
        </AppButton2>
      </div>
      <div class="flex flex-col flex-1">
        <AppButton2
          href="/prywatny-dom-opieki/#faq"
          class="w-full"
        >
          <span class="text-Menu">Pytania, które najczęściej słyszymy</span>
        </AppButton2>
        <AppButton2
          href="/prywatny-dom-opieki/#cennik"
          class="w-full"
        >
          <span class="text-Menu">Cennik</span>
        </AppButton2>
        <AppButton2
          href="/prywatny-dom-opieki/#kontakt"
          class="w-full"
        >
          <span class="text-Menu">Kontakt</span>
        </AppButton2>
      </div>
    </div>
  </div>
</template>
